module.exports = __webpack_public_path__ + "static/img/robot-function.f264e46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/robot-function.png
// module id = sy6W
// module chunks = 1